import Vue from 'vue';
import Vuex from 'vuex';

import app from './modules/app';
import shop from './modules/shop';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    app,
    shop,
  },
});

export default store;
